module.exports = __webpack_public_path__ + "static/media/chat_guide.2952bab6.png";